import React, { useEffect, useState } from "react";
import { previewUrl } from "../../lib/api";
import { renderAdjustedThumb } from "../../lib/cropThumb";

// Shows the ORIGINAL preview for un-adjusted photos (centered cover, unchanged
// look). For photos the customer adjusted, it renders the exact saved
// crop/rotation/zoom so the grid preview matches the printed magnet.
export const AdjustedThumb = ({ magnet, className, alt = "" }) => {
  const original = previewUrl(magnet.photo_id);
  const [src, setSrc] = useState(original);
  const isAdjusted = !!(magnet.adjusted && magnet.crop);

  useEffect(() => {
    let alive = true;
    if (!isAdjusted) { setSrc(original); return undefined; }
    renderAdjustedThumb(original, magnet.crop, magnet.rotation || 0)
      .then((url) => { if (alive && url) setSrc(url); })
      .catch(() => { if (alive) setSrc(original); });
    return () => { alive = false; };
  }, [original, isAdjusted, magnet.crop, magnet.rotation]);

  return <img src={src} alt={alt} className={className} draggable={false} />;
};
